
export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <div className="brand">
      <img className="brand-logo" src="/arena-logo-20260915.png" alt="Arena Sul Minas Beach Sports" width={60} height={60} />
      {!compact && <span><strong>ARENA SUL MINAS</strong><small>BEACH SPORTS</small></span>}
    </div>
  );
}
